import React, { useEffect } from 'react';
import fileDownload from 'js-file-download';
import { Box, Typography, useTheme } from '@mui/material';
import Table from './Table';
import './ManagerView.css';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { UploadedFile } from '../../types/files';

const ManagerView = () => {
  const theme = useTheme();
  const axiosPrivate = useAxiosPrivate();
  const [files, setFiles] = React.useState<UploadedFile[]>([]);

  useEffect(() => {
    const getFiles = () => {
      axiosPrivate
        // reportId=expo is hardcoded for now, will need to ensure the reportID is correct for expo report when it is created
        .get('/files/manager?reportId=expo')
        .then((response: { data: UploadedFile[] }) => {
          setFiles(response.data);
        })
        .catch((error: Error) => {
          // eslint-disable-next-line no-console
          console.error(error);
        });
    };
    getFiles();
  }, [axiosPrivate]);

  const downloadFile = (fileName: string) => {
    // reportId=expo is hardcoded for now, will need to ensure the reportID is correct for expo report when it is created

    axiosPrivate
      .get(`/files/managerDownload?reportId=expo&fileName=${fileName}`, {
        responseType: 'blob',
      })
      .then((response) => {
        fileDownload(response.data, `${fileName}`);
      })
      .catch((error: Error) => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
  };

  return (
    <Box>
      {/* this title is hardcoded for now, will need to ensure the reportID is correct for expo report when it is created */}
      <Typography
        variant="h4"
        className="manager-report-title"
        sx={{ marginBottom: theme.spacing(1) }}
      >
        EXPO Report Name
      </Typography>
      <Table files={files} downloadFile={downloadFile} />
    </Box>
  );
};

export default ManagerView;
